import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Typography, Select, notification } from 'antd';
import { MailOutlined, LockOutlined, SmileOutlined } from '@ant-design/icons';
import './login.css';
import logo from '../../../../icon.png';
import { useNavigate } from 'react-router-dom';
import { UserService } from '../../../Services/Manage/UserService';
import { GeneralService } from '../../../Services/General/GeneralService';
import { PermissionService } from '../../../Services/Permission/PermissionService';

const { Title } = Typography;

const LoginPage = () => {
  const navigate = useNavigate();
  const [roleOption, setRoleOption] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [step, setStep] = useState("validate"); // "validate" | "createPassword" | "enterPassword"
  const [uid, setUid] = useState("");

  const getAllRole = async () => {
    try {
      const request = await GeneralService.getAllRole();
      setRoleOption(
        request.data.map((item) => ({
          value: item.name,
          label: item.name
        }))
      );
    } catch (error) {
      api.error({ message: 'Error', description: 'Failed to load roles' });
    }
  };

  useEffect(() => { getAllRole(); }, []);

  // Step 1: Validate UID + Role
  const onValidateFinish = async (values) => {
    try {
      const response = await UserService.authValidation(values);
      if (response.status) {
        setUid(values.uid);
        const response_login = await UserService.login(values);

        console.log(response_login);


        if (response_login.status) {
          // setStep("createPassword");
          setStep("enterPassword");

          // here log entred password in form
          api.success({ message: 'User Found', description: response_login.message || "Please enter a password." });
        } else {

          setStep("createPassword");
          // here log entred password in form
          api.success({ message: 'User Found', description: response_login.message || "Please create password." });
        }
      } else {
        api.error({ message: 'Login Failed', description: response.message || 'Invalid UID or Role' });
      }
    } catch (error) {
      api.error({ message: 'Error', description: error.message || 'An error occurred during login' });
    }
  };

  // Step 2: Create Password
  const onCreatePasswordFinish = async (values) => {
    try {
      console.log("Create password:", { uid, password: values.password });
      const request = await UserService.createpass({ uid, password: values.password });
      console.log(request);

      if (request.status) {
        api.success({ message: "Password Created", description: request.message || "You can now login!" });
        setStep("enterPassword");
      } else {
        api.error({ message: "Error !", description: request.message || "Try again!" });
      }

    } catch (error) {
      console.error(error);

    }

  };

  // Step 3: Enter Password
  const onLoginFinish = async (values) => {

    try {
      console.log("what man with:", { uid, password: values.password });

      const request = await UserService.logpass({ uid, password: values.password });

      if (request.status) {

        const response = await PermissionService.getPermissionDetailsById(uid);

        console.log(response.data);


        localStorage.setItem("ome_token", request.token);
        localStorage.setItem("ome_user", JSON.stringify(request.data));

        const permissions =
          response?.data?.permissions || response?.permissions || [];

        localStorage.setItem(
          "ome_permission",
          JSON.stringify(permissions)
        );


        console.log("Login response:", request);

        window.location.reload();
        api.success({
          message: "Login Success!",
          description: request.message || "Welcome back!",
        });


      } else {
        api.error({
          message: "Please check your password!",
          description: request.message || "Try again!",
        });
      }

    } catch (error) {
      console.error(error);

    }
  };

  return (
    <div className="login-container">
      {contextHolder}
      <Card className="login-card" variant="borderless">
        <Title className="login-title">Office Management System Demo</Title>
        <div className="login-content">
          <div className="login-left">
            <img src={logo} alt="Knex.js Logo" style={{ width: '250px', height: 'auto' }} />
          </div>

          <div className="login-right">
            {step === "validate" && (
              <>
                <Title level={4}>Login</Title>
                <Form name="validate" onFinish={onValidateFinish} layout="vertical">

                  <Form.Item
                    name="uid"
                    rules={[{ required: true, message: 'Please input your UID!' }]}
                    initialValue="1009-0001"
                  >
                    <Input
                      allowClear
                      size="large"
                      placeholder="Use this UID : 1009-0001"
                      prefix={<SmileOutlined />}
                    />
                  </Form.Item>

                  <Form.Item name="role" rules={[{ required: true, message: 'Please select your Role!' }]}>
                    <Select
                      allowClear
                      options={roleOption}
                      size="large"
                      placeholder="Use role: Admin"
                    />

                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" size="large" block>VALIDATE</Button>
                  </Form.Item>
                </Form>
              </>
            )}

            {step === "createPassword" && (
              <>
                <Title level={4}>Create Password</Title>
                <Form
                  name="createPassword"
                  onFinish={onCreatePasswordFinish}
                  layout="vertical"
                >

                  <Form.Item initialValue={uid} name="uid" rules={[{ required: true, message: 'Please input your UID!' }]}>
                    <Input disabled size="large" placeholder="UID" prefix={<SmileOutlined />} />
                  </Form.Item>

                  {/* Password */}
                  <Form.Item
                    name="password"
                    rules={[
                      { required: true, message: 'Please input a password!' },
                    ]}
                    hasFeedback
                  >
                    <Input.Password
                      size="large"
                      placeholder="Password"
                      prefix={<LockOutlined />}
                    />
                  </Form.Item>

                  {/* Confirm Password */}
                  <Form.Item
                    name="confirmPassword"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                      { required: true, message: 'Please confirm your password!' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('The two passwords do not match!'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Confirm Password"
                      prefix={<LockOutlined />}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </Form.Item>

                  {/* Submit */}
                  <Form.Item>
                    <Button type="primary" htmlType="submit" size="large" block>
                      Create Password
                    </Button>
                  </Form.Item>

                  {/* Back */}
                  <Form.Item>
                    <Button size="large" block onClick={() => setStep("validate")}>
                      Back
                    </Button>
                  </Form.Item>
                </Form>
              </>
            )}


            {step === "enterPassword" && (
              <>
                <Title level={4}>Enter Password</Title>
                <Form name="loginPassword" onFinish={onLoginFinish} layout="vertical">
                  <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Password : 123"
                      prefix={<LockOutlined />}
                    />

                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" size="large" block>
                      Login
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button size='large' block onClick={() => setStep("validate")}>
                      Back
                    </Button>
                  </Form.Item>
                </Form>
              </>
            )}

          </div>
        </div>

        <div className="login-footer">
          Powered by <span>ShreeshTech Digital Solutions</span>
        </div>
      </Card>




    </div>
  );
};

export default LoginPage;
